module.exports = __webpack_public_path__ + "img/a_huevos.71f7a7af.svg";